<script lang="ts">
</script>

<div class="flex flex-col justify-items-center items-center mx-auto">
  <div class="shadow rounded bg-yellow-50 w-10/12 content-center p-1">
    <div class="flex-1 m-4">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>■返却が必要な機器</p>
          <p class="ml-4">ターミナルアダプタ、ACアダプタ、スタンド</p>
          <p>■返却先</p>
          <ul class="list-disc ml-4">
            <li>
              <p>住所：〒259-1304 神奈川県秦野市堀山下320 ロジスティード南関東株式会社</p>
            </li>
            <li>
              <p>宛名： U-NEXT光01サービスアルテリアネットワークス配送センター宛て</p>
            </li>
          </ul>
          <ul class="list-none">
            <li>
              <p>※着払いでお送りください</p>
            </li>
            <li>
              <p>※手続きを進めるまえにお書留めください</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  p {
    @apply text-sm tracking-normal mb-1;
  }
</style>
